<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Motivo_rechazo_cod"
      label="Código"
      type="text"
      v-model="formData.Motivo_rechazo_cod"
      :readonly="isEditing"
      :required="true"
      :maxlength="20"
      helpText="Código del motivo de rechazo"
    />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre del motivo de rechazo (máximo 100 caracteres)"
    />
    
    <FormField
      id="Es_activo"
      label="Estado"
      type="checkbox"
      v-model="formData.Es_activo"
      checkboxLabel="Motivo de rechazo activo"
      helpText="Indica si el motivo de rechazo está activo en el sistema"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';

export default {
  name: 'MotivoRechazoForm',
  components: {
    FormField
  },
  props: {
    motivoRechazo: {
      type: Object,
      default: () => ({
        Motivo_rechazo_cod: '',
        Nombre: '',
        Es_activo: true
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.motivoRechazo }
    };
  },
  watch: {
    motivoRechazo: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formData });
    }
  }
};
</script>
